import React, { useState } from 'react'
import { supabase } from '../../supabase'
import Logo from '../common/Logo'

function EcranAbonnement({ userId, userEmail, onActivated }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const activer = async () => {
    setLoading(true)
    setError('')
    try {
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, email: userEmail }),
      })
      const data = await response.json()
      if (data.url) {
        window.location.href = data.url
      } else {
        setError('Erreur lors de la redirection vers le paiement.')
        setLoading(false)
      }
    } catch (err) {
      setError('Erreur : ' + err.message)
      setLoading(false)
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 460, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
            <Logo size="lg" />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Activation abonnement</h2>
          <p style={{ color: '#718096', fontSize: 14 }}>Votre compte est cree. Activez votre abonnement pour commencer.</p>
        </div>
        <div style={{ background: '#e8f7f2', borderRadius: 12, padding: '20px 24px', marginBottom: 24, textAlign: 'center', border: '2px solid #b8e8d8' }}>
          <div style={{ fontSize: 42, fontWeight: 800, color: '#1D9E75', lineHeight: 1 }}>20€</div>
          <div style={{ fontSize: 14, color: '#718096', marginTop: 4 }}>par mois, sans engagement</div>
          <div style={{ display: 'inline-block', marginTop: 10, padding: '4px 12px', background: '#1D9E75', color: 'white', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
            30 jours offerts a l activation
          </div>
        </div>
        <div style={{ marginBottom: 24 }}>
          {[
            'Chantiers illimites avec codes acces uniques',
            'Partage instantane avec entreprises (code)',
            'Acces client en lecture sans inscription',
            'Gestion taches, documents et photos',
            'Acces entreprises et clients entierement gratuit',
          ].map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
              <span style={{ width: 20, height: 20, background: '#1D9E75', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 11, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
              <span style={{ fontSize: 14, color: '#4a5568' }}>{f}</span>
            </div>
          ))}
        </div>
        {error && <div className="error-msg">{error}</div>}
        <button onClick={activer} disabled={loading} style={{ width: '100%', padding: 14, background: '#1D9E75', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Redirection vers le paiement...' : 'Activer mon abonnement - 20€/mois'}
        </button>
        <div style={{ fontSize: 12, color: '#a0aec0', textAlign: 'center', marginTop: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
          <span>🔒</span> Paiement sécurisé par Stripe
        </div>
      </div>
    </div>
  )
}

function EcranConfirmationEmail({ email, onBackToLogin }) {
  const [renvoi, setRenvoi] = useState(false)
  const [loading, setLoading] = useState(false)

  const renvoyer = async () => {
    setLoading(true)
    await supabase.auth.resend({ type: 'signup', email })
    setLoading(false)
    setRenvoi(true)
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '48px 40px', width: '100%', maxWidth: 440, boxShadow: '0 8px 32px rgba(0,0,0,0.1)', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <Logo size="lg" />
        </div>
        <div style={{ fontSize: 56, marginBottom: 20 }}>📧</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 12 }}>
          Verifiez votre email
        </h2>
        <p style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.7, marginBottom: 24 }}>
          Un lien de confirmation a ete envoye a<br />
          <strong style={{ color: '#1D9E75' }}>{email}</strong><br />
          Cliquez dessus pour activer votre compte.
        </p>
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 18px', marginBottom: 28, fontSize: 13, color: '#718096', lineHeight: 1.6 }}>
          Pensez a verifier vos <strong>spams</strong> si vous ne voyez pas l email dans votre boite de reception.
        </div>
        {renvoi ? (
          <div style={{ fontSize: 14, color: '#1D9E75', fontWeight: 500, marginBottom: 20 }}>
            Email renvoye ! Verifiez votre boite.
          </div>
        ) : (
          <button onClick={renvoyer} disabled={loading} style={{
            width: '100%', marginBottom: 12, padding: '11px 0', background: '#e8f7f2',
            border: '1.5px solid #c6f6d5', borderRadius: 8, color: '#1D9E75', fontSize: 14,
            fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1,
          }}>
            {loading ? 'Envoi...' : 'Renvoyer l email de confirmation'}
          </button>
        )}
        <button onClick={onBackToLogin} style={{
          background: 'none', border: 'none', color: '#718096', fontSize: 14, cursor: 'pointer',
        }}>
          Retour a la connexion
        </button>
      </div>
    </div>
  )
}

export default function RegisterPage({ onRegistered, onBackToLogin }) {
  const [step, setStep] = useState('form') // 'form' | 'abonnement' | 'confirm_email'
  const [userId, setUserId] = useState(null)
  const [emailInscrit, setEmailInscrit] = useState('')
  const [form, setForm] = useState({ prenom: '', nom: '', email: '', password: '', passwordConfirm: '', role: 'entreprise' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (form.password !== form.passwordConfirm) { setError('Les mots de passe ne correspondent pas.'); return }
    if (form.password.length < 6) { setError('Le mot de passe doit contenir au moins 6 caracteres.'); return }
    setLoading(true)

    const { data: authData, error: authError } = await supabase.auth.signUp({ email: form.email, password: form.password })
    if (authError) { setError('Erreur : ' + authError.message); setLoading(false); return }

    const uid = authData.user.id
    await supabase.from('profiles').upsert([{
      id: uid, email: form.email, prenom: form.prenom, nom: form.nom, role: form.role,
      abonnement_actif: true, date_expiration: null, // MODE BETA: accès gratuit
    }])

    setLoading(false)
    setEmailInscrit(form.email)
    setUserId(uid)

    // MODE BETA: accès direct sans paiement
    setStep('confirm_email')
  }

  if (step === 'abonnement') return <EcranAbonnement userId={userId} userEmail={emailInscrit} onActivated={() => setStep('confirm_email')} />
  if (step === 'confirm_email') return <EcranConfirmationEmail email={emailInscrit} onBackToLogin={onBackToLogin} />

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 14, padding: '36px 40px', width: '100%', maxWidth: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <Logo size="md" withText={true} />
        </div>
        <h1 style={{ fontSize: 20, fontWeight: 700, marginTop: 16, marginBottom: 4 }}>Creer un compte</h1>
        <p style={{ fontSize: 13, color: '#718096', marginBottom: 24 }}>
          Architectes et entreprises uniquement. Les clients accedent via un code.
        </p>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Prenom *</label>
              <input className="form-input" required value={form.prenom} onChange={e => setForm({ ...form, prenom: e.target.value })} placeholder="Jean" />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Nom *</label>
              <input className="form-input" required value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Dupont" />
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Votre role *</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[
                { value: 'entreprise', label: 'Entreprise', sub: 'Gratuit', icon: '🔨', desc: 'Taches et photos' },
                { value: 'architecte', label: 'Architecte / MOE', sub: 'Gratuit (bêta)', icon: '🏛️', desc: 'Pilote les chantiers' },
              ].map(r => (
                <button key={r.value} type="button" onClick={() => setForm({ ...form, role: r.value })} style={{
                  padding: '12px 10px', borderRadius: 8, textAlign: 'center', cursor: 'pointer',
                  border: form.role === r.value ? '2px solid #1D9E75' : '2px solid #e2e8f0',
                  background: form.role === r.value ? '#e8f7f2' : 'white', transition: 'all 0.15s',
                }}>
                  <div style={{ fontSize: 22, marginBottom: 4 }}>{r.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: form.role === r.value ? '#1D9E75' : '#2d3748' }}>{r.label}</div>
                  <div style={{ fontSize: 10, color: form.role === r.value ? '#1D9E75' : '#a0aec0' }}>{r.sub}</div>
                  <div style={{ fontSize: 11, color: '#718096', marginTop: 3 }}>{r.desc}</div>
                </button>
              ))}
            </div>
            {form.role === 'architecte' && (
              <div style={{ marginTop: 8, padding: '8px 10px', background: '#fffbeb', borderRadius: 6, fontSize: 12, color: '#92400e', border: '1px solid #fef3c7' }}>
                Abonnement a 20€/mois — 30 jours offerts a l inscription
              </div>
            )}
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Email *</label>
            <input className="form-input" type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="votre@email.com" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Mot de passe *</label>
            <input className="form-input" type="password" required value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Min. 6 caracteres" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#4a5568', marginBottom: 5 }}>Confirmer le mot de passe *</label>
            <input className="form-input" type="password" required value={form.passwordConfirm} onChange={e => setForm({ ...form, passwordConfirm: e.target.value })} placeholder="Repetez le mot de passe" />
          </div>

          <button type="submit" disabled={loading} style={{ width: '100%', padding: 11, background: '#1D9E75', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Creation...' : (form.role === 'architecte' ? 'Creer mon compte' : 'Creer mon compte gratuit')}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <span style={{ fontSize: 13, color: '#718096' }}>Deja un compte ? </span>
          <button onClick={onBackToLogin} style={{ background: 'none', border: 'none', color: '#1D9E75', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
            Se connecter
          </button>
        </div>
        <div style={{ marginTop: 16, padding: '10px 12px', background: '#f5f6fa', borderRadius: 8, fontSize: 12, color: '#718096', textAlign: 'center' }}>
          Vous etes client ? Pas besoin de compte.<br />
          <button onClick={onBackToLogin} style={{ background: 'none', border: 'none', color: '#1D9E75', fontSize: 12, cursor: 'pointer', fontWeight: 500 }}>
            Acces direct par code chantier →
          </button>
        </div>
      </div>
    </div>
  )
}
